module.exports = __webpack_public_path__ + "img/Indonesia-08.f65109b3.jpg";